import React from 'react';

interface ICheckboxIcon {
  checked?: boolean;
  disabled?: boolean;
}

const CheckboxIcon: React.FC<ICheckboxIcon> = props => {
  const { checked, disabled } = props;
  if (checked && !disabled) {
    return (
      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="1.5"
          stroke="#3E75FF"
        />
        <path
          d="M12 5L6.5 10.5L4 8"
          stroke="#3E75FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
      <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="#E6E9F0" />
      {disabled && (
        <line
          x1="4"
          y1="8"
          x2="12"
          y2="8"
          stroke="#E6E9F0"
          strokeWidth="2"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
};

export default CheckboxIcon;
